"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStructureOrderCount = exports.useFSAOrderCount = exports.useLendingPositions = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const TradeAPILib_1 = require("TradeAPILib");
const trade_utils_lib_1 = require("trade_utils_lib");
const trade_asset_lib_1 = require("trade_asset_lib");
const useLendingPositions = (tradeAPI, isFocused = true) => {
    const [positions, setPositions] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!tradeAPI || !isFocused) {
            return;
        }
        const sub = (0, trade_utils_lib_1.requestWithRetry)(() => {
            return tradeAPI.queryFMPositions();
        }, { maxRetryCount: 2, name: "useLendingPositions" })
            .pipe((0, operators_1.map)((res) => {
            return res.filter((e) => {
                return e.total !== "0";
            });
        }))
            .subscribe((res) => {
            setPositions(res !== null && res !== void 0 ? res : []);
        }, (error) => { });
        return () => {
            sub.unsubscribe();
        };
    }, [tradeAPI, isFocused]);
    return positions;
};
exports.useLendingPositions = useLendingPositions;
const useFSAOrderCount = (tradeAPI, isFocused = true) => {
    const queryBotOrderCount = (0, react_1.useCallback)((tradeAPI, orderType) => {
        const params = {
            status: "running",
            orderType: orderType,
        };
        return tradeAPI.getMarketBotOrdersCountByStatus(params);
    }, []);
    const [count, setCount] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!tradeAPI || !isFocused) {
            return;
        }
        const fsa$ = queryBotOrderCount(tradeAPI, TradeAPILib_1.ExchangeOrderType.fsa);
        const cmFsa$ = queryBotOrderCount(tradeAPI, TradeAPILib_1.ExchangeOrderType.cm_fsa);
        const sub = (0, rxjs_1.forkJoin)(fsa$, cmFsa$).subscribe((data) => {
            setCount(data[0] + data[1]);
        }, (error) => { });
        return () => {
            sub.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFocused, tradeAPI]);
    return count;
};
exports.useFSAOrderCount = useFSAOrderCount;
const useStructureOrderCount = (apiKey, isFocused = true) => {
    const autoAPI = (0, react_1.useMemo)(() => {
        if (apiKey) {
            return (0, trade_asset_lib_1.DCAutoApi)(apiKey);
        }
    }, [apiKey]);
    const queryAllAutoOrders = (0, react_1.useCallback)((list) => {
        if (!autoAPI || (list && list.has_more === false)) {
            return (0, rxjs_1.of)(list);
        }
        return (0, trade_utils_lib_1.requestWithRetry)(() => {
            return autoAPI.records(trade_asset_lib_1.DCAutoOrderType.dual_auto, list === null || list === void 0 ? void 0 : list.next_token);
        }, { maxRetryCount: 2, name: "useStructureOrderCount_auto" }).pipe((0, operators_1.flatMap)((list) => {
            return queryAllAutoOrders(list);
        }));
    }, [autoAPI]);
    const manualAPI = (0, react_1.useMemo)(() => {
        if (apiKey) {
            return (0, trade_asset_lib_1.DCMV2)(apiKey);
        }
    }, [apiKey]);
    const queryAllManualOrders = (0, react_1.useCallback)((list) => {
        var _a;
        if (!manualAPI || (list && list.has_more === false)) {
            return (0, rxjs_1.of)(list);
        }
        const params = {
            filter: trade_asset_lib_1.DualOrderFilterType.OPEN,
            limit: 20,
            end_time: ((_a = list === null || list === void 0 ? void 0 : list.records) === null || _a === void 0 ? void 0 : _a.length) ? list.records[list.records.length - 1].create_time - 1 : new Date().getTime(),
        };
        return (0, trade_utils_lib_1.requestWithRetry)(() => {
            return manualAPI.queryInvestRecordsV2(params);
        }, { maxRetryCount: 2, name: "useStructureOrderCount_manaul" }).pipe((0, operators_1.flatMap)((list) => {
            return queryAllManualOrders(list);
        }));
    }, [manualAPI]);
    const [count, setCount] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!isFocused) {
            return;
        }
        const sub = (0, rxjs_1.forkJoin)(queryAllAutoOrders(), queryAllManualOrders()).subscribe((data) => {
            var _a, _b, _c, _d, _e, _f;
            const autoCount = (_c = (_b = (_a = data[0]) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
            const maualCount = (_f = (_e = (_d = data[1]) === null || _d === void 0 ? void 0 : _d.records) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0;
            setCount(autoCount + maualCount);
        }, (error) => { });
        return () => {
            sub.unsubscribe();
        };
    }, [queryAllAutoOrders, queryAllManualOrders, isFocused]);
    return count;
};
exports.useStructureOrderCount = useStructureOrderCount;
